<script setup lang="ts">
import { ref, reactive, onMounted, onUnmounted, computed } from 'vue'
import Introduction1 from '@/assets/Introduction1.png'
import Introduction2 from '@/assets/Introduction2.png'
import Introduction3 from '@/assets/Introduction3.png'
import tool1 from '@/assets/tool1.png'
import tool2 from '@/assets/tool2.png'
import tool3 from '@/assets/tool3.png'
import tool4 from '@/assets/tool4.png'
import tool5 from '@/assets/tool5.png'
import pd_yfesp32 from '@/assets/pd_yfesp32.png'
import pd_yf3300 from '@/assets/pd_yf3300.png'
import pd_yf3028 from '@/assets/pd_yf3028.png'
import pd_yf2020 from '@/assets/pd_yf2020.png'
import pd_yf3008 from '@/assets/pd_yf3008.png'
import pd_yf3610 from '@/assets/pd_yf3610.png'
import pd_yfrc3000 from '@/assets/pd_yfrc3000.png'
import pd_yfair8000 from '@/assets/pd_yfair8000.png'
import pd_SixCubicT from '@/assets/pd_SixCubicT.png'
import pd_custom from '@/assets/pd_custom.png'
import moreIcon from '@/assets/more.png'
import advantage1 from '@/assets/advantage1.png'
import advantage2 from '@/assets/advantage2.png'
import advantage3 from '@/assets/advantage3.png'
import advantage4 from '@/assets/advantage4.png'
import com from '@/assets/com.png'
import wechatQr from '@/assets/wechatQr.png'
import case1 from '@/assets/case1.png'
import case2 from '@/assets/case2.png'
import case3 from '@/assets/case3.png'
import case4 from '@/assets/case4.png'
import case5 from '@/assets/case5.png'
import case6 from '@/assets/case6.png'
import case7 from '@/assets/case7.png'

const docsApi = import.meta.env.VITE_APP_DOCS_API
const iotApi = import.meta.env.VITE_APP_IOT_API
const showBr = window.innerWidth <= 768
const showMobileMenu = ref(false)
const showQr = ref(false)
const previewImage = ref<string | null>(null)
const previewScale = ref(1)
const previewRotation = ref(0)
const previewDragging = ref(false)
const previewDragStart = ref({ x: 0, y: 0 })
const previewTranslate = reactive({ x: 0, y: 0 })

const iconPhone = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>`
const iconWechat = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>`
const iconEmail = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>`
const iconQr = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h1v4h4v1h-5z"/><path d="M18 17h1"/></svg>`

const copyWechat = () => {
  navigator.clipboard?.writeText('YFSOFT').then(() => { }).catch(() => { })
}

const toggleQr = () => {
  showQr.value = !showQr.value
}

const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value
}

const closeMobileMenu = () => {
  showMobileMenu.value = false
}

// 软件平台数据
const softwareProducts = [
  { name: 'YFIOs·叶帆物联', desc: '支持多用户、多项目、多设备统一管理，提供设备接入、AI数据治理、模型训练与监管等全栈服务', tag: '云端平台', icon: tool1, gradient: 'linear-gradient(135deg, #0066ff 0%, #0088ff 100%)', shadow: 'rgba(13, 148, 136, 0.25)', link: docsApi + '/docs/yfios/platform' },
  { name: 'YFIOs·边缘智能', desc: '支持嵌入式组态、零/低代码可视化开发，实现网关设备在线监控与边缘侧实时数据交互', tag: '边缘计算', icon: tool3, gradient: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)', shadow: 'rgba(245, 158, 11, 0.25)', link: docsApi + '/docs/yfios-edge/platform' },
  { name: 'YFIOs·云端管理工具', desc: '支持设备批量创建、多设备实时数据/历史曲线对比及设备状态监控，一键启用多设备模拟仿真', tag: '云端工具', icon: tool2, gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', shadow: 'rgba(99, 102, 241, 0.25)', link: docsApi + '/docs/tools/cloud-manager/yfios-cloud-manager' },
  { name: 'YFIOs·终端模拟器', desc: '支持单/多设备模拟仿真，提供属性动态上报、事件推送及服务指令下发等全流程模拟能力', tag: '终端工具', icon: tool4, gradient: 'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)', shadow: 'rgba(236, 72, 153, 0.25)', link: docsApi + '/docs/tools/terminal-tools//yfios-terminal-simulator' },
  { name: 'YFIOs·远程监管助手', desc: '微信小程序免安装即用，支持扫码监控设备实时状态、查看数据、回溯历史曲线及下发远程指令', tag: '移动工具', icon: tool5, gradient: 'linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%)', shadow: 'rgba(6, 182, 212, 0.25)', link: docsApi + '/docs/tools/mobile-tools/yfios-helper' },
]

// 硬件产品数据
const devBoards = [
  { name: 'YFESP32开发板', desc: '基于乐鑫模组打造的开发板，支持 C# / C++ 开发，提供完整示例与 SDK，可快速接入 YFIOs平台', models: 'WiFi / Bluetooth / 4G(可选)', icon: pd_yfesp32, link: docsApi + '/docs/hardware/devboard/yfesp32' },
  { name: '硬件定制', desc: '面向 STM32、ESP32、睿擎核心板、合宙 4G 模组等主流硬件，提供一站式定制与深度开发服务。', models: '多协议和多接口支持', icon: pd_custom, link: undefined },
]

const gateways = [
  { name: 'YF3300系列', desc: '轻量级物联网关，支持YFIOs组态开发，零代码或低代码(C#)即可实现设备快速入云', models: '1路4G / 1路RS485 / 1路RS232 / 2路开关量入 / 1路继电器出', icon: pd_yf3300, link: docsApi + '/docs/hardware/gateway/yf3300' },
  { name: 'YF3028系列', desc: '工业级物联网关，支持YFIOs组态开发(上百种驱动支持)，零代码或低代码(C#)即可实现设备快速入云', models: '多规格支持: 4G / Ethernet / RS485 / RS232 / CAN / PowerBUS / LoRa', icon: pd_yf3028, link: docsApi + '/docs/hardware/gateway/yf3028' },
  { name: 'YF2020系列', desc: '子母型物联网关，支持YFIOs组态开发，零代码或低代码(C#)即可实现设备快速入云', models: '多规格支持: 4G / Ethernet / RS485 / RS232 / CAN / PowerBUS / LoRa', icon: pd_yf2020, link: docsApi + '/docs/hardware/gateway/yf2020' },
  { name: 'YF3008系列', desc: '无网口型物联网关，支持YFIOs组态开发，零代码或低代码(C#)即可实现设备快速入云', models: '多规格支持: 4G / RS485 / RS232 / PowerBUS ', icon: pd_yf3008, link: docsApi + '/docs/hardware/gateway/yf3008' },
  { name: 'YFRC3000系列', desc: '基于睿擎核心板打造的工业边缘智能网关，EtherCAT、OPC-UA、CANopen、Modbus等工业协议', models: '4G / Ethernet / WiFi / Bluetooth / RS485 / RS232 / CAN / LoRa', icon: pd_yfrc3000, link: docsApi + '/docs/hardware/gateway/yfrc3000' },
  { name: 'YFAir8000系列', desc: '基于合宙Air8000打造的工业物联网关，支持LUA二次开发，支持无线有线路由等功能', models: 'WiFi / 4G / Ethernet / Bluetooth / RS485 / RS232', icon: pd_yfair8000, link: docsApi + '/docs/hardware/gateway/yfair8000' },
]

const sensors = [
  { name: 'YF3610系列', desc: '工业级传感器，多种产品类型（温度/湿度/氨气/氧气/二氧化碳/气压/PM2.5/光照等）', models: 'RS485(Modbus)', icon: pd_yf3610, link: docsApi + '/docs/hardware/sensor/yf3610' },
  { name: '六方塔系列', desc: '室外型工业级传感器，多种通信类型，多种产品类型（温度/湿度/二氧化碳/气压/PM2.5/光照等）', models: 'RS485(Modbus) / 4G(MQTT)', icon: pd_SixCubicT, link: docsApi + '/docs/hardware/sensor/SixCubicT' },
]

// 核心定位
const coreValues = [
  {
    title: '架构级',
    slogan: '十年磨一剑',
    desc: '全栈式工业物联数智底座',
    // icon: corePosition1, 
    color: '#0066ff',
    bg: 'rgba(13, 148, 136, 0.1)'
  },
  {
    title: '算力级',
    slogan: '十万终端',
    desc: '云边端一体工业算力中枢',
    // icon: corePosition2, 
    color: '#6366f1',
    bg: 'rgba(99, 102, 241, 0.1)'
  },
  {
    title: '赋能级',
    slogan: '全链路贯通',
    'desc': '从数据采集到智能决策闭环',
    // icon: corePosition3, 
    color: '#f59e0b',
    bg: 'rgba(245, 158, 11, 0.1)'
  },
  {
    title: '生态级',
    slogan: 'AIoT赋能',
    desc: '连接工业全要素，构建开放生态',
    // icon: corePosition4, 
    color: '#ec4899',
    bg: 'rgba(236, 72, 153, 0.1)'
  },
]

// 平台优势
const advantages = [
  { title: '十年技术深耕', desc: '从工业组态到单芯片级轻量化接入，技术路线持续迭代，筑牢工业物联核心能力。', icon: advantage1 },
  { title: '云边端一体化架构', desc: '全链路贯通，单机支撑数十万智能终端稳定接入，保障工业场景高可靠运行。', icon: advantage2 },
  { title: '全栈式物联能力', desc: '覆盖嵌入式、网关、传感器及云端平台，提供从硬件到应用的一体化解决方案。', icon: advantage3 },
  { title: 'AI驱动数智转型', desc: '一站式数据采集、治理、分析，赋能预测性维护、智能决策，加速企业数智化转型。', icon: advantage4 },
]

// 核心卖点
const sellingPoints = [
  {
    title: '重新定义".NET 工业开发"',
    subtitle: '让每一位 C# 程序员都能直接驱动硬件',
    desc: '技术闭环：.NET 开发板 + YFIOs 嵌入式组态 + YFIOs 物联平台，打通从硬件到云端的全链路。效率跃迁：过去需 1 个嵌入式工程师 + 1 个后端工程师对接 1 个月，现在 1 个 C# 程序员 3 天即可完成联调上线，大幅缩短项目周期。',
    // icon: coreValue1,
    gradient: 'linear-gradient(135deg, #0066ff 0%, #0088ff 100%)'
  },
  {
    title: '专注"边缘侧"的数据治理',
    subtitle: '为 AI 分析筑牢高质量数据根基',
    desc: '可视化清洗引擎：精准过滤工业现场海量、高噪数据，支持中值滤波、均值平滑、异常剔除等多种算法，智能修复信号跳变、数据断帧等问题。极简操作：拖拽式可视化配置，无需编码即可快速完成数据预处理，显著提升 AI 模型准确率与分析效率。',
    // icon: coreValue2,
    gradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'
  },
]

// 特色功能
const features = [
  {
    title: '私有化IoT基础设施',
    desc: '深耕传统制造业场景，满足工厂数据不出厂的核心刚需，支持Docker一键部署，快速构建专属、安全的IoT基础设施。',
    // icon: feature3,
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  },
  {
    title: 'AI驱动预测性维护',
    desc: '集成轻量级机器学习算法，精准预测设备寿命与故障风险，提前干预，实现预测性维护，大幅降低停机成本。',
    // icon: feature2,
    gradient: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)'
  },
  {
    title: '全协议兼容能力',
    desc: '全面兼容Modbus、OPC UA、CANopen、S7-NET等百余种工业协议，实现设备无缝接入与数据互通，打通工业全场景连接。',
    // icon: feature4,
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    title: '容器化边缘部署',
    desc: '基于Docker的模块化、容器化中间件，支持树莓派、工控机等边缘节点快速部署，实现数据不出厂的安全交付。',
    // icon: feature1,
    gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
  },
]

// 图文卡片
const contentCards = [
  {
    tag: '自主研发物联数智平台',
    title: '从芯片到云端，十年磨一剑',
    desc: '叶帆科技历经十余年技术深耕与行业沉淀，自主研发 YFIOs 物联数智平台。从早期工业组态软件，到如今超小体积的单芯片级嵌入式组态，我们打通了从芯片、终端到云端的全链路，让各类传感器、工业设备实现极速接入与轻量化部署，为工业场景提供更高效、更灵活的物联解决方案。',
    points: ['芯片级嵌入式组态', '极速接入各类设备', '轻量化部署'],
    reverse: false,
    img: Introduction1
  },
  {
    tag: '云边端一体',
    title: '云端单机支撑数十万终端',
    desc: 'YFIOs 已全面升级为云、边、端一体化智能物联架构，具备高可靠、低延迟、易扩展的工业级核心能力。平台深度覆盖嵌入式系统、工业接入网关、多品类传感器及云端管理平台，构建起从设备感知、数据传输、边缘计算到智能应用的全栈物联闭环，为工业场景提供稳定高效的连接底座。',
    points: ['高并发接入', '低延迟响应', '易扩展架构'],
    reverse: true,
    img: Introduction2
  },
  {
    tag: 'AI 赋能',
    title: '打通 OT 与 IT 数据壁垒',
    desc: 'YFIOs 以开放、兼容、安全、智能为核心，深度融合 AI 技术，打破 OT 与 IT 间的数据孤岛，提供一站式设备接入、数据采集、治理、分析与智能应用服务，为智能制造、工业互联网、智慧物联等场景，打造高效协同的 AI 时代数智底座。',
    points: ['AI 数据治理', '智能应用服务', 'OT/IT 融合'],
    reverse: false,
    img: Introduction3
  }
]

const stats = [
  { value: '10万+', label: '终端并发' },
  { value: '50ms', label: '平均时延' },
  { value: '99.99%', label: '系统可用性' },
  { value: '100+', label: '协议支持' },
]

const checkItems = [
  ' 芯片级工业组态，传感器接入快人一步',
  ' 云边端一体，单机轻松管数十万台终端',
  ' 嵌入式网关传感器，全栈生态全面覆盖'
]

// 典型案例
const cases = ref([
  { id: 1, title: '智慧养殖', desc: '', icon: case1 },
  { id: 2, title: '智慧水务', desc: '', icon: case2 },
  { id: 3, title: '抽水蓄能', desc: '', icon: case3 },
  { id: 4, title: '智慧电力', desc: '', icon: case4 },
  { id: 5, title: '智慧消防', desc: '', icon: case5 },
  { id: 6, title: '智慧农业', desc: '', icon: case6 },
  { id: 7, title: '能耗管理', desc: '', icon: case7 },
])
const currentCaseIndex = ref(0)
const currentCaseTitle = ref('智慧养殖') // 当前案例标题（动态更新）
let caseInterval: ReturnType<typeof setInterval> | null = null

// 计算可见的5张图片（实现无限滚动）
const visibleCases = computed(() => {
  const len = cases.value.length
  const centerIdx = currentCaseIndex.value
  // 获取前后各1张图片的索引
  const indices = [
    (centerIdx - 1 + len) % len,  // prev
    centerIdx,                     // center
    (centerIdx + 1) % len,        // next
  ]
  return indices.map(i => cases.value[i]!)
})

const nextCase = () => {
  currentCaseIndex.value = (currentCaseIndex.value + 1) % cases.value.length
  currentCaseTitle.value = cases.value[currentCaseIndex.value]!.title
}

const prevCase = () => {
  currentCaseIndex.value = (currentCaseIndex.value - 1 + cases.value.length) % cases.value.length
  currentCaseTitle.value = cases.value[currentCaseIndex.value]!.title
}

const goToCase = (index: number) => {
  currentCaseIndex.value = index
  currentCaseTitle.value = cases.value[currentCaseIndex.value]!.title
}

const openPreview = (img: string) => {
  previewImage.value = img
  previewScale.value = 1
  previewRotation.value = 0
  previewTranslate.x = 0
  previewTranslate.y = 0
}

const closePreview = () => {
  previewImage.value = null
  previewScale.value = 1
  previewRotation.value = 0
  previewTranslate.x = 0
  previewTranslate.y = 0
}

const zoomIn = () => {
  previewScale.value = Math.min(previewScale.value + 0.25, 4)
}

const zoomOut = () => {
  previewScale.value = Math.max(previewScale.value - 0.25, 0.25)
}

const rotateLeft = () => {
  previewRotation.value -= 90
}

const rotateRight = () => {
  previewRotation.value += 90
}

const resetPreview = () => {
  previewScale.value = 1
  previewRotation.value = 0
  previewTranslate.x = 0
  previewTranslate.y = 0
}

const handlePreviewWheel = (e: WheelEvent) => {
  e.preventDefault()
  if (e.deltaY < 0) {
    zoomIn()
  } else {
    zoomOut()
  }
}

const startDrag = (e: MouseEvent | TouchEvent) => {
  previewDragging.value = true
  if ('touches' in e) {
    previewDragStart.value = { x: e.touches[0]!.clientX - previewTranslate.x, y: e.touches[0]!.clientY - previewTranslate.y }
  } else {
    previewDragStart.value = { x: e.clientX - previewTranslate.x, y: e.clientY - previewTranslate.y }
  }
}

const onDrag = (e: MouseEvent | TouchEvent) => {
  if (!previewDragging.value) return
  if ('touches' in e) {
    previewTranslate.x = e.touches[0]!.clientX - previewDragStart.value.x
    previewTranslate.y = e.touches[0]!.clientY - previewDragStart.value.y
  } else {
    previewTranslate.x = e.clientX - previewDragStart.value.x
    previewTranslate.y = e.clientY - previewDragStart.value.y
  }
}

const endDrag = () => {
  previewDragging.value = false
}

const startAutoPlay = () => {
  caseInterval = setInterval(nextCase, 100000)
}

const stopAutoPlay = () => {
  if (caseInterval) {
    clearInterval(caseInterval)
    caseInterval = null
  }
}

// 触摸滑动
let touchStartX = 0
let touchEndX = 0

const handleTouchStart = (e: TouchEvent) => {
  touchStartX = e.touches[0]!.clientX
}

const handleTouchMove = (e: TouchEvent) => {
  touchEndX = e.touches[0]!.clientX
}

const handleTouchEnd = () => {
  const diff = touchStartX - touchEndX
  const threshold = 50
  if (diff > threshold) {
    nextCase()
  } else if (diff < -threshold) {
    prevCase()
  }
}

onMounted(() => {
  startAutoPlay()
  document.addEventListener('click', handleOutsideClick)
})

onUnmounted(() => {
  stopAutoPlay()
  document.removeEventListener('click', handleOutsideClick)
})

const handleOutsideClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement
  if (!target.closest('.contact-btn-qr')) {
    showQr.value = false
  }
}
</script>

<template>
  <div class="app">
    <!-- 导航 -->
    <header class="navbar">
      <div class="navbar-container">
        <a href="/" class="logo">
          <img src="@/assets/YFSOFT.ico" alt="logo" class="logo-img" />
          <span class="logo-text">YFIOs·叶帆物联</span>
        </a>
        <div class="navbar-right">
          <a :href="iotApi" class="btn nav-btn btn-secondary">立即体验</a>
          <a :href="docsApi" class="btn nav-btn btn-secondary">文档中心</a>
          <a :href="docsApi + '/docs/deploy'" class="btn nav-btn btn-primary">免费部署</a>
          <!-- 移动端菜单图标 -->
          <img :src="moreIcon" alt="更多" class="mobile-menu-icon" @click="toggleMobileMenu" />
        </div>
        <!-- 移动端下拉菜单 -->
        <div class="mobile-menu" :class="{ active: showMobileMenu }">
          <a :href="iotApi" class="mobile-menu-link" @click="closeMobileMenu">立即体验</a>
          <a :href="docsApi" class="mobile-menu-link" @click="closeMobileMenu">文档中心</a>
          <a :href="docsApi + '/docs/deploy'" class="mobile-menu-link" @click="closeMobileMenu">免费部署</a>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="hero">
      <div class="hero-bg"></div>
      <div class="hero-particles"></div>
      <div class="container hero-content">
        <div class="hero-badge">
          <span class="badge-dot"></span>
          一叶启帆·万物智联
        </div>
        <!-- ▪ -->
        <h1 class="hero-title">
          <span class="title-highlight">YFIOs®</span>
          <br />
          AI 时代工业物联数智底座
        </h1>
        <p class="hero-subtitle">
          叶帆科技十余年深耕物联网领域，打造 YFIOs 云边端一体数智平台
          <br />单机支撑数十万终端并发，全栈物联能力，一站式数据采集与治理
        </p>
        <div class="hero-tagline">软硬一体·全域接入·数据治理·智能决策</div>

        <div class="hero-btns">
          <a :href="docsApi + '/docs/deploy'" class="btn btn-primary btn-lg">免费部署</a>
          <a :href="docsApi" class="btn btn-outline btn-lg">查看文档</a>
        </div>

        <div class="hero-stats">
          <div v-for="s in stats" :key="s.label" class="stat-item">
            <div class="stat-value">{{ s.value }}</div>
            <div class="stat-label">{{ s.label }}</div>
          </div>
        </div>

      </div>
    </section>

    <!-- 云边协同 -->
    <section id="software" class="section software-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">CLOUD-EDGE COLLABORATION</div>
          <h2 class="section-title">云边协同</h2>
          <p class="section-desc">一站式AI 物联网开发平台，覆盖设备接入、数据治理、云端管控、边缘智能、在线调试，打造全链路智能物联开发体验。</p>
        </div>
        <div class="software-cards-wrapper">
          <a v-for="(item, index) in softwareProducts" :key="index" class="software-card" :href="item.link"
            target="_blank" :style="{ '--card-gradient': item.gradient, '--card-shadow': item.shadow }">
            <div class="card-glow"></div>
            <div class="card-icon">
              <img :src="item.icon" alt="card-image" class="card-image" />
            </div>
            <div class="card-content">
              <span class="card-tag">{{ item.tag }}</span>
              <h3 class="card-name">{{ item.name }}</h3>
              <p class="card-desc">{{ item.desc }}</p>
            </div>
          </a>
        </div>
      </div>
    </section>

    <!-- 数智设备 -->
    <section id="hardware" class="section hardware-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">SMART DIGITAL DEVICES</div>
          <h2 class="section-title">数智设备</h2>
          <p class="section-desc">从开发板到工业级硬件，支持深度定制，全方位满足各类物联场景需求。</p>
        </div>

        <!-- 开发板 -->
        <div class="hardware-group">
          <h3 class="hardware-group-title">开发板 & 硬件定制</h3>
          <div class="hardware-flex-list">
            <a v-for="(item, index) in devBoards" :key="index" :href="item.link" target="_blank"
              class="hardware-flex-card">
              <div class="hardware-flex-image">
                <img :src="item.icon" alt="">
              </div>
              <div class="hardware-flex-content">
                <h4 class="hardware-flex-name">{{ item.name }}</h4>
                <p class="hardware-flex-desc">{{ item.desc }}</p>
                <span class="hardware-flex-protocol">{{ item.models }}</span>
              </div>
            </a>
          </div>
        </div>

        <!-- 工业级网关 -->
        <div class="hardware-group">
          <h3 class="hardware-group-title">工业级网关</h3>
          <div class="hardware-flex-list">
            <a v-for="(item, index) in gateways" :key="index" :href="item.link" target="_blank"
              class="hardware-flex-card">
              <div class="hardware-flex-image">
                <img :src="item.icon" alt="">
              </div>
              <div class="hardware-flex-content">
                <h4 class="hardware-flex-name">{{ item.name }}</h4>
                <p class="hardware-flex-desc">{{ item.desc }}</p>
                <span class="hardware-flex-protocol">{{ item.models }}</span>
              </div>
            </a>
          </div>
        </div>

        <!-- 工业级传感器 -->
        <div class="hardware-group">
          <h3 class="hardware-group-title">工业级传感器</h3>
          <div class="hardware-flex-list">
            <a v-for="(item, index) in sensors" :key="index" :href="item.link" target="_blank"
              class="hardware-flex-card">
              <div class="hardware-flex-image">
                <img :src="item.icon" alt="">
              </div>
              <div class="hardware-flex-content">
                <h4 class="hardware-flex-name">{{ item.name }}</h4>
                <p class="hardware-flex-desc">{{ item.desc }}</p>
                <span class="hardware-flex-protocol">{{ item.models }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心定位 -->
    <section id="core" class="section core-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">CORE POSITION</div>
          <h2 class="section-title">核心定位</h2>
          <p class="section-desc">架构、算力、赋能、生态，四位一体打造工业物联数智底座</p>
        </div>
        <div class="core-grid">
          <div v-for="(item, index) in coreValues" :key="index" class="core-card"
            :style="{ '--accent-color': item.color, '--accent-bg': item.bg }">
            <!-- <div class="core-icon">
              <img :src="item.icon" alt="" style="width: 60px;">
            </div> -->
            <div class="core-slogan">{{ item.slogan }}</div>
            <h3 class="core-title">{{ item.title }}</h3>
            <p class="core-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心卖点 -->
    <section class="section selling-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">CORE VALUE</div>
          <h2 class="section-title">核心价值</h2>
          <p class="section-desc">以技术创新重构工业物联价值</p>
        </div>
        <div class="selling-grid">
          <div v-for="(item, index) in sellingPoints" :key="index" class="selling-card"
            :style="{ '--card-gradient': item.gradient }">
            <!-- <div class="selling-icon">
              <img :src="item.icon" alt="" style="width: 100px;">
            </div> -->
            <div class="selling-content">
              <h3 class="selling-title">{{ item.title }}</h3>
              <p class="selling-subtitle">{{ item.subtitle }}</p>
              <p class="selling-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 图文卡片 -->
    <section class="section content-section">
      <div class="container">
        <div v-for="(card, index) in contentCards" :key="index" class="content-card"
          :class="{ 'card-reverse': card.reverse }">
          <div class="content-image">
            <div class="image-placeholder">
              <img :src="card.img" alt="card-image" class="card-image" />
            </div>
          </div>
          <div class="content-text">
            <span class="content-tag">{{ card.tag }}</span>
            <h3 class="content-title">{{ card.title }}</h3>
            <p class="content-desc">{{ card.desc }}</p>
            <ul class="content-points">
              <li v-for="point in card.points" :key="point">✓ {{ point }}</li>
            </ul>
            <!-- <a href="#" class="content-link">了解更多 →</a> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 特色功能 -->
    <section id="features" class="section features-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">FEATURES</div>
          <h2 class="section-title">特色功能</h2>
          <p class="section-desc">AI数据治理 + 容器化部署，赋能工业数智化转型</p>
        </div>
        <div class="features-grid">
          <div v-for="(item, index) in features" :key="index" class="feature-card"
            :style="{ '--card-gradient': item.gradient }">
            <!-- <div class="feature-icon">
              <img :src="item.icon" alt="" style="width: 100px;">
            </div> -->
            <h3 class="feature-title">{{ item.title }}</h3>
            <p class="feature-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 平台优势 -->
    <section id="advantages" class="section advantages-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">ADVANTAGES</div>
          <h2 class="section-title">平台优势</h2>
          <p class="section-desc">十年技术深耕，构建云边端一体的工业物联数智底座</p>
        </div>
        <div class="advantages-grid">
          <div v-for="(item, index) in advantages" :key="index" class="advantage-card">
            <div class="advantage-icon">
              <img :src="item.icon" alt="" style="width: 63px;">
            </div>
            <h3 class="advantage-title">{{ item.title }}</h3>
            <p class="advantage-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型案例 -->
    <section class="section cases-section">
      <div class="container">
        <div class="section-header">
          <div class="section-tag">TYPICAL CASES</div>
          <h2 class="section-title">典型案例</h2>
          <p class="section-desc">覆盖多行业物联场景，助力企业数智化转型</p>
          <p class="case-current-title">{{ currentCaseTitle }}</p>
        </div>
        <div class="cases-carousel" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay"
          @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
          <div class="carousel-wrapper">
            <div class="carousel-slides">
              <div v-for="(c, idx) in visibleCases" :key="c.id + '-' + idx" class="carousel-slide" :class="{
                'is-prev': idx === 0,
                'is-center': idx === 1,
                'is-next': idx === 2
              }">
                <div class="case-card" :class="{ 'is-clickable': true }"
                  @click="idx === 1 ? openPreview(c.icon) : (idx === 0 ? prevCase() : nextCase())">
                  <div class="case-image">
                    <img :src="c.icon" :alt="c.title" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-nav carousel-prev" @click="prevCase" v-if="!showBr">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </div>
          <div class="carousel-nav carousel-next" @click="nextCase" v-if="!showBr">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
          <div class="carousel-dots">
            <span v-for="(c, idx) in cases" :key="c.id" class="dot" :class="{ active: idx === currentCaseIndex }"
              @click="goToCase(idx)"></span>
          </div>
        </div>
      </div>
    </section>

    <!-- 图片预览弹窗 -->
    <div v-if="previewImage" class="preview-overlay" @click="closePreview" @mousedown="startDrag" @mousemove="onDrag"
      @mouseup="endDrag" @mouseleave="endDrag" @touchstart="startDrag" @touchmove="onDrag" @touchend="endDrag"
      @wheel="handlePreviewWheel">
      <div class="preview-content" @click.stop>
        <img :src="previewImage" alt="预览图片" class="preview-image" :style="{
          transform: `translate(${previewTranslate.x}px, ${previewTranslate.y}px) scale(${previewScale}) rotate(${previewRotation}deg)`,
          cursor: previewDragging ? 'grabbing' : 'grab'
        }" />
        <div class="preview-tools">
          <button class="preview-tool-btn" @click.stop="zoomIn" title="放大">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <line x1="11" y1="8" x2="11" y2="14"></line>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
          </button>
          <button class="preview-tool-btn" @click.stop="zoomOut" title="缩小">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
          </button>
          <button class="preview-tool-btn" @click.stop="rotateLeft" title="左转">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <polyline points="1 4 1 10 7 10"></polyline>
              <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
            </svg>
          </button>
          <button class="preview-tool-btn" @click.stop="rotateRight" title="右转">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <polyline points="23 4 23 10 17 10"></polyline>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
          </button>
          <button class="preview-tool-btn" @click.stop="resetPreview" title="重置">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
              <path d="M3 3v5h5"></path>
            </svg>
          </button>
        </div>
        <button class="preview-close" @click="closePreview">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>

    <!-- CTA -->
    <section class="cta">
      <div class="cta-bg"></div>
      <div class="container">
        <h2 class="cta-title">十年磨一剑，叶帆YFIOs 重构工业物联新范式！</h2>
        <p class="cta-desc">AI时代工业物联数智底座，让设备可感知、让数据可驱动，为工业场景筑牢核心竞争力</p>
        <div class="cta-points">
          <div v-for="item in checkItems" :key="item" class="check-item">✓ {{ item }}</div>
        </div>
        <div class="cta-slogans">
          <span class="slogan-main">YFIOs：从芯片到云端，AI时代工业物联数智底座</span>
          <span class="slogan-sub">叶帆科技，让工业物联更智能、更高效、更安全</span>
        </div>
        <div class="cta-btns">
          <a :href="docsApi + '/docs/deploy'" class="btn btn-white btn-lg">免费部署</a>
          <a :href="docsApi + '/docs/yfios-introduction'" class="btn btn-outline-white btn-lg">技术文档</a>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <div class="footer-center">
          <div class="footer-main">
            <div class="footer-brand">
              <div class="footer-logo">
                <img src="@/assets/YFSOFT.ico" alt="logo" class="footer-logo-img" />
                <span class="footer-logo-text">YFIOs·叶帆物联</span>
              </div>
            </div>
            <p class="footer-slogan">YFIOs：从芯片到云端，一叶启帆，万物智联</p>
            <div class="footer-filing">
              <img :src="com" alt="备案信息" class="filing-icon" />
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011502003712" target="_blank"
                rel="noopener noreferrer" class="footer-icp">京公网安备 11011502003712号</a>
              <div v-if="showBr" />
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"
                class="footer-icp">京ICP备13037425号-5</a>
            </div>
            <p class="footer-copyright">© 2026 叶帆科技 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
    <div class="footer-contact-strip">
      <!-- href="tel:010-86486288" -->
      <a href="javascript:;" class="contact-btn" title="联系电话">
        <span class="contact-btn-icon" v-html="iconPhone"></span>
        <span class="contact-btn-text">+86 18500167449</span>
      </a>
      <a href="javascript:;" class="contact-btn" title="微信号 YFSOFT" @click.prevent="copyWechat">
        <span class="contact-btn-icon" v-html="iconWechat"></span>
        <span class="contact-btn-text">公众号：叶帆科技</span>
      </a>
      <!-- href="mailto:yefan@yfios.com" -->
      <a href="javascript:;" class="contact-btn" title="邮箱">
        <span class="contact-btn-icon" v-html="iconEmail"></span>
        <span class="contact-btn-text">yefan@yfiot.com</span>
      </a>
      <a href="javascript:;" class="contact-btn contact-btn-qr" :class="{ active: showQr }" title="微信二维码"
        @click.prevent="toggleQr">
        <span class="contact-btn-icon contact-qr-icon" v-html="iconQr"></span>
        <span class="contact-qr-wrap">
          <img :src="wechatQr" alt="微信二维码" width="80" height="80" />
        </span>
      </a>
    </div>
  </div>
</template>

<style>
/* 隐藏滚动条 */
::-webkit-scrollbar {
  display: none;
}

* {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@300;400;500;600;700;800&display=swap'); */

.app {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 50%, #f0f9ff 100%);
  font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Navbar */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 40px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  text-decoration: none;
}

.logo-img {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.logo-text {
  color: #0A2C8C;
}

.logo-domain {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  padding: 4px 10px;
  background: #f1f5f9;
  border-radius: 12px;
  margin-left: 8px;
}

.navbar-nav {
  display: flex;
  gap: 6px;
}

.nav-link {
  padding: 10px 16px;
  color: #475569;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s;
}

.nav-link:hover {
  color: #0066ff;
  background: rgba(13, 148, 136, 0.08);
}

.navbar-right {
  display: flex;
  gap: 12px;
}

.mobile-menu-icon {
  display: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.mobile-menu {
  display: none;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.25s;
}

.nav-btn {
  font-size: 16px;
}

.btn-secondary {
  color: #475569;
  background: transparent;
}

.btn-secondary:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.btn-primary {
  color: #ffffff;
  background: #0066ff;
  box-shadow: 0 4px 14px rgba(13, 105, 148, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(48, 150, 218, 0.4);
}

.btn-outline {
  color: #1b76ff;
  border: 1.5px solid #1b76ff;
  background: rgba(13, 148, 136, 0.05);
}

.btn-outline:hover {
  border-color: #0066ff;
  color: #0066ff;
  /* background: rgba(36, 167, 255, 0.329); */
  transform: translateY(-2px);
}

.btn-outline-white {
  color: #ffffff;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  background: transparent;
}

.btn-outline-white:hover {
  background: rgba(255, 255, 255, 0.15);
}

.btn-white {
  color: #0066ff;
  background: #ffffff;
}

.btn-white:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.btn-lg {
  padding: 14px 32px;
  font-size: 16px;
}

/* Hero */
.hero {
  position: relative;
  padding: 180px 0 140px;
  overflow: hidden;
  /* background: linear-gradient(180deg, #e0f2fe 0%, #ffffff 50%, #f0f9ff 100%); */
  background: url('@/assets/index.png');
  background-size: cover;
  background-position: center;
}

.hero-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0, 100, 255, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse 50% 40% at 80% 100%, rgba(0, 200, 255, 0.1) 0%, transparent 40%);
}

.hero-particles {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 30%, rgba(13, 148, 136, 0.15) 0%, transparent 1%),
    radial-gradient(circle at 80% 70%, rgba(99, 102, 241, 0.1) 0%, transparent 1%);
  background-size: 50px 50px;
}

.hero-content {
  position: relative;
  text-align: center;
  z-index: 1;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  margin-bottom: 32px;
  font-size: 14px;
  font-weight: 600;
  color: #008fff;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 140, 255, .7);
  border-radius: 30px;
}

.badge-dot {
  /*width: 8px;
  height: 8px;
  background: #0b6ac2;
  border-radius: 50%;*/
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.hero-title {
  font-size: 72px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
  margin-bottom: 24px;
  letter-spacing: -2px;
}

.title-highlight {
  background: linear-gradient(135deg, #0066ff 0%, #1f608b 50%, #6395f1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding-right: 0.5px
}

.hero-subtitle {
  font-size: 20px;
  color: #64748b;
  max-width: 720px;
  margin: 0 auto 20px;
  line-height: 1.8;
}

.hero-tagline {
  font-size: 18px;
  font-weight: 600;
  color: #0066ff;
  margin-bottom: 40px;
}

.hero-btns {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 60px;
}

.hero-stats {
  display: inline-flex;
  justify-content: center;
  gap: 130px;
  padding: 32px 48px;
  /* background: #ffffff; */
  /* border: 1px solid #e2e8f0; */
  border-radius: 16px;
  /* box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04); */
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 36px;
  font-weight: 700;
  color: #0066ff;
}

.stat-label {
  font-size: 14px;
  color: #000000;
  margin-top: 4px;
}

/* Sections */
.section {
  padding: 100px 0;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-tag {
  display: inline-block;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #0066ff;
  background: rgba(13, 148, 136, 0.1);
  border-radius: 20px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 42px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
}

.section-desc {
  font-size: 18px;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
}

.case-current-title {
  margin: 18px 0 0 0;
  font-size: 24px;
  color: #1816a8;
  font-weight: 500;
}

/* Software Section */
.software-section {
  background: linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 40%, #f0f9ff 100%);
  padding: 80px 0;
}

.software-cards-wrapper {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 50px;
  padding: 20px 0;
}

.software-card {
  position: relative;
  padding: 28px 20px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
}

.software-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--card-gradient);
  opacity: 0;
  transition: opacity 0.3s;
}

.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: var(--card-gradient);
  opacity: 0;
  transition: opacity 0.4s;
  filter: blur(60px);
  z-index: 0;
}

.software-card:hover {
  transform: translateY(-8px);
  border-color: transparent;
  box-shadow: 0 20px 40px var(--card-shadow);
}

.software-card:hover::before {
  opacity: 1;
}

.software-card:hover .card-glow {
  opacity: 0.08;
}

.card-icon {
  position: relative;
  z-index: 1;
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: var(--card-gradient); */
  border-radius: 16px;
  box-shadow: 0 6px 16px var(--card-shadow);
}

.icon-emoji {
  font-size: 26px;
}

.card-content {
  position: relative;
  z-index: 1;
}

.card-tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #ffffff;
  background: var(--card-gradient);
  padding: 4px 12px;
  border-radius: 20px;
  margin-bottom: 12px;
}

.card-name {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
  line-height: 1.3;
}

.card-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.software-arrow {
  font-size: 20px;
  color: #cbd5e1;
  transition: all 0.3s;
}

.software-card:hover .software-arrow {
  color: #0066ff;
  transform: translateX(4px);
}

/* Hardware Section */
.hardware-section {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 50%, #f8fafc 100%);
}

.hardware-group {
  margin-bottom: 48px;
}

.hardware-group:last-child {
  margin-bottom: 0;
}

.hardware-group-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.group-icon {
  font-size: 24px;
}

/* 新的flex卡片样式 */
.hardware-flex-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hardware-flex-card {
  display: flex;
  flex-direction: column;
  width: 230px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s;
}

.hardware-flex-card:hover {
  border-color: #6366f1;
  box-shadow: 0 8px 30px rgba(99, 102, 241, 0.12);
}

.hardware-flex-image {
  width: 100%;
  /* height: 220px; */
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  padding: 16px;
}

.hardware-flex-image img {
  width: 100%;
  /* max-height: 100%; */
  object-fit: contain;
}

.hardware-flex-content {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.hardware-flex-name {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.hardware-flex-desc {
  font-size: 13px;
  color: #64748b;
  line-height: 1.4;
  margin-bottom: 10px;
  flex: 1;
}

.hardware-flex-protocol {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #0066ff;
  background: rgba(0, 102, 255, 0.1);
  padding: 4px 10px;
  border-radius: 12px;
}

.hardware-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.hardware-card {
  padding: 26px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  transition: all 0.3s;
}

.hardware-card:hover {
  border-color: #6366f1;
  box-shadow: 0 8px 30px rgba(99, 102, 241, 0.12);
}

.hardware-card.dev-card:hover {
  border-color: #0066ff;
  box-shadow: 0 8px 30px rgba(13, 148, 136, 0.12);
}

.hardware-icon {
  font-size: 36px;
  margin-bottom: 14px;
}

.hardware-name {
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.hardware-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 12px;
}

.hardware-protocol {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: #6366f1;
  background: rgba(99, 102, 241, 0.1);
  padding: 4px 10px;
  border-radius: 6px;
}

/* Core Section */
.core-section {
  background: linear-gradient(180deg, #f8fafc 0%, #f0fdfa 100%);
}

.core-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.core-card {
  position: relative;
  padding: 32px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s;
  overflow: hidden;
}

.core-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--accent-color);
}

.core-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

.core-icon {
  font-size: 40px;
  margin-bottom: 14px;
}

.core-slogan {
  font-size: 13px;
  font-weight: 700;
  color: var(--accent-color);
  letter-spacing: 1px;
  margin-bottom: 8px;
}

.core-title {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 10px;
}

.core-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

/* Selling Section */
.selling-section {
  background: #ffffff;
}

.selling-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.selling-card {
  display: flex;
  gap: 24px;
  padding: 32px;
  background: var(--card-gradient);
  border-radius: 20px;
  color: #ffffff;
}

.selling-icon {
  width: 100px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selling-content {
  flex: 1;
}

.selling-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
}

.selling-subtitle {
  font-size: 15px;
  font-weight: 600;
  opacity: 0.9;
  margin-bottom: 14px;
}

.selling-desc {
  font-size: 14px;
  opacity: 0.85;
  line-height: 1.7;
}

/* Content Cards */
.content-section {
  background: #f8fafc;
  padding: 80px 0;
}

.content-card {
  display: flex;
  align-items: center;
  gap: 60px;
  padding: 60px 0;
  border-bottom: 1px solid #e2e8f0;
}

.content-card:last-child {
  border-bottom: none;
}

.content-card.card-reverse {
  flex-direction: row-reverse;
}

.content-image {
  flex: 1;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-radius: 20px;
  color: #94a3b8;
  font-size: 15px;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}


.content-text {
  flex: 1;
}

.content-tag {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  color: #0066ff;
  background: rgba(13, 148, 136, 0.1);
  padding: 4px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.content-title {
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 16px;
}

.content-desc {
  font-size: 16px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 20px;
}

.content-points {
  list-style: none;
  padding: 0;
  margin-bottom: 24px;
}

.content-points li {
  font-size: 14px;
  color: #0066ff;
  font-weight: 500;
  margin-bottom: 8px;
}

.content-link {
  font-size: 15px;
  font-weight: 600;
  color: #0066ff;
  text-decoration: none;
  transition: all 0.2s;
}

.content-link:hover {
  color: #0f766e;
}

/* Features Section */
.features-section {
  background: #ffffff;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.feature-card {
  position: relative;
  padding: 26px;
  background: var(--card-gradient);
  border-radius: 20px;
  color: #ffffff;
  overflow: hidden;
}

.feature-card::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
}

.feature-icon {
  font-size: 34px;
  margin-bottom: 14px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}

.feature-desc {
  font-size: 13px;
  opacity: 0.9;
  line-height: 1.6;
  position: relative;
  z-index: 1;
}

/* Advantages Section */
.advantages-section {
  background: linear-gradient(180deg, #f0fdfa 0%, #e0f2fe 50%, #f0f9ff 100%);
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.advantage-card {
  padding: 32px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s;
}

.advantage-card:hover {
  border-color: #0066ff;
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(13, 148, 136, 0.1);
}

.advantage-icon {
  width: 68px;
  height: 68px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  /*background: linear-gradient(135deg, rgba(13, 148, 136, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%);
  border-radius: 18px;*/
}

.advantage-title {
  font-size: 19px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 10px;
}

.advantage-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

/* 典型案例 */
.cases-section {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 50%, #f8fafc 100%);
  overflow: hidden;
}

.cases-carousel {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0 60px;
}

.carousel-wrapper {
  overflow: visible;
  border-radius: 20px;
}

.carousel-slides {
  display: flex;
  transition: transform 0.5s ease;
  justify-content: center;
}

.carousel-slide {
  flex: 0 0 45%;
  padding: 0 10px;
  box-sizing: border-box;
  transition: all 0.4s ease;
  position: relative;
}

.carousel-slide.is-prev,
.carousel-slide.is-next {
  opacity: 0.6;
  transform: scale(0.75);
  z-index: 1;
}

.carousel-slide.is-prev {
  padding-right: 0;
  margin-right: -15%;
}

.carousel-slide.is-next {
  padding-left: 0;
  margin-left: -15%;
}

.carousel-slide.is-center {
  opacity: 1;
  transform: scale(1);
  z-index: 10;
}

.case-card {
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
}

.case-card.is-clickable {
  cursor: pointer;
}

.case-card.is-clickable:hover {
  box-shadow: 0 12px 40px rgba(0, 102, 255, 0.25);
}

.carousel-slide.is-center .case-card {
  box-shadow: 0 16px 48px rgba(0, 102, 255, 0.2);
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.carousel-slide.is-center .case-image img {
  transform: scale(1.05);
}

.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  z-index: 20;
}

.carousel-nav:hover {
  background: #0066ff;
  color: #ffffff;
  transform: translateY(-50%) scale(1.1);
}

.carousel-prev {
  left: 0;
}

.carousel-next {
  right: 0;
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 24px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #cbd5e1;
  cursor: pointer;
  transition: all 0.3s;
}

.dot.active {
  background: #0066ff;
  width: 24px;
  border-radius: 5px;
}

/* CTA */
.cta {
  position: relative;
  padding: 100px 0;
  text-align: center;
  background: linear-gradient(135deg, #0066ff 0%, #186aa0 50%, #63a5f1 100%);
  overflow: hidden;
}

.cta-bg {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.06) 0%, transparent 50%);
}

.cta .container {
  position: relative;
  z-index: 1;
}

.cta-title {
  font-size: 38px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
}

.cta-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 28px;
}

.cta-points {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 28px;
}

.check-item {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.95);
}

.cta-slogans {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 36px;
}

.slogan-main {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.slogan-sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
}

.cta-btns {
  display: flex;
  gap: 16px;
  justify-content: center;
}

/* Footer */
.footer {
  padding: 60px 0 30px;
  background: #0f172a;
}

.footer-center {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  gap: 24px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.footer-logo-img {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.footer-logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.footer-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.footer-slogan {
  color: #94a3b8;
  font-size: 14px;
  margin: 8px 0;
}

.footer-contact-strip {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
  z-index: 100;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0;
  border-radius: 10px;
  background: rgb(1, 124, 252);
  color: #fff;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 44px;
  width: 44px;
  height: 44px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.contact-btn:hover {
  width: 180px;
  padding: 0 12px;
  justify-content: flex-start;
  background: #007bff;
}

.contact-btn-text {
  font-size: 14px;
  font-weight: 600;
  opacity: 0;
  width: 0;
  overflow: hidden;
  padding: 0;
  margin: 0;
  transition: opacity 0.2s ease, width 0.3s ease;
}

.contact-btn:hover .contact-btn-text {
  opacity: 1;
  width: auto;
}

.contact-btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.contact-btn:hover .contact-btn-icon {
  position: static;
  transform: none;
}

.contact-btn-icon svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.contact-btn:hover,
.contact-btn:hover {
  background: #007bff;
}

.contact-btn-qr {
  position: relative;
}

.contact-btn-qr img {
  display: none;
  width: 80px;
  height: 80px;
  object-fit: contain;
  flex-shrink: 0;
}

.contact-btn-qr:hover {
  width: 100px;
  height: 100px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.contact-btn-qr:hover .contact-qr-icon {
  display: none;
}

.contact-btn-qr:hover img {
  display: block;
}

.contact-btn-qr:hover .contact-btn-icon {
  position: static;
  transform: none;
  margin-bottom: 4px;
}

/* 点击展开样式 */
.contact-btn-qr.active {
  width: 100px;
  height: 100px;
  padding: 10px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.contact-btn-qr.active .contact-qr-icon {
  display: none;
}

.contact-btn-qr.active img {
  display: block;
}

.contact-btn-qr.active .contact-btn-icon {
  position: static;
  transform: none;
  margin-bottom: 4px;
}

.footer-filing {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(180, 210, 255, 0.7);
}

.filing-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.footer-icp {
  font-size: 12px;
  color: rgba(180, 210, 255, 0.7);
}

.footer-filing a {
  color: inherit;
  text-decoration: none;
  font-size: 12px;
}

.footer-filing a:hover {
  text-decoration: underline;
}

.footer-copyright {
  font-size: 14px;
  color: #64748b;
  margin-top: 8px;
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-title {
    font-size: 54px;
  }

  .core-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .selling-grid {
    grid-template-columns: 1fr;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .advantages-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .content-card {
    flex-direction: column;
    gap: 40px;
  }

  .content-card.card-reverse {
    flex-direction: column;
  }

  .footer-main {
    flex-direction: column;
    align-items: center;
  }

  .footer-links {
    gap: 40px;
    flex-wrap: wrap;
  }

  .software-cards-wrapper {
    grid-template-columns: repeat(3, 1fr);
  }

  .footer-bottom {
    align-items: flex-start;
  }

  /* 轮播图响应式 */
  .cases-carousel {
    max-width: 800px;
    padding: 0 50px;
  }

  .carousel-slide {
    flex: 0 0 45%;
  }

  .carousel-slide.is-prev,
  .carousel-slide.is-next {
    transform: scale(0.75);
  }

  .case-image {
    height: 280px;
  }

  .carousel-nav {
    width: 40px;
    height: 40px;
  }

  .carousel-slide.is-center {
    transform: scale(1);
  }

  .footer-contact-strip {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    z-index: 100;
  }

  .contact-btn {
    width: 44px !important;
    height: 44px;
    padding: 0;
  }

  .contact-btn:hover {
    width: 165px !important;
    padding: 0 12px;
    justify-content: flex-start;
  }

  .contact-btn-qr:hover {
    width: 100px !important;
    padding: 0;
    justify-content: flex-start;
  }

  .contact-btn-text {
    opacity: 0 !important;
    width: 0 !important;
    font-size: 12px;
  }

  .contact-btn:hover .contact-btn-text {
    opacity: 1 !important;
    width: auto !important;
  }

  .contact-btn-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .contact-btn:hover .contact-btn-icon {
    position: static;
    transform: none;
  }

  .contact-btn-qr img {
    display: none;
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }

  .contact-btn-qr:hover {
    width: 100px;
    height: 100px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .contact-btn-qr:hover img {
    display: block;
  }

  .contact-btn-qr:hover .contact-btn-icon {
    position: static;
    transform: none;
    margin-bottom: 4px;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 12px 16px;
  }

  .navbar-container {
    flex-wrap: wrap;
    height: unset;
    position: relative;
    padding: 0;
  }

  .logo {
    gap: 8px;
  }

  .logo-img {
    width: 28px;
    height: 28px;
  }

  .logo-text {
    font-size: 16px;
  }

  .navbar-right {
    gap: 8px;
    align-items: center;
  }

  .navbar-right .btn {
    display: none;
  }

  .mobile-menu-icon {
    display: block;
  }

  .mobile-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    flex-direction: column;
    padding: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-menu.active {
    display: flex;
  }

  .mobile-menu-link {
    padding: 12px 16px;
    font-size: 14px;
    color: #333;
    text-decoration: none;
    border-bottom: 1px solid #eee;
  }

  .mobile-menu-link:last-child {
    border-bottom: none;
  }

  .mobile-menu-link:hover {
    background: #f5f5f5;
  }

  .hero {
    padding: 60px 16px;
    min-height: auto;
  }

  .hero-title {
    font-size: 32px;
    line-height: 1.2;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .hero-tagline {
    font-size: 14px;
  }

  .hero-stats {
    flex-wrap: wrap;
    gap: 16px;
    padding: 20px;
    justify-content: center;
  }

  .stat-item {
    flex: 0 0 calc(50% - 8px);
    flex-direction: row;
    gap: 12px;
    text-align: center;
    justify-content: center;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-label {
    font-size: 14px;
  }

  /* .hero-btns { flex-direction: column; align-items: center; gap: 12px; } */
  .hero-btns .btn {
    width: 100%;
    max-width: 240px;
  }

  .section {
    padding: 48px 16px;
  }

  .section-title {
    font-size: 26px;
  }

  .section-desc {
    font-size: 14px;
  }

  .section-tag {
    font-size: 11px;
  }

  .software-cards-wrapper {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .software-card {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .card-glow {
    display: none;
  }

  .card-icon {
    width: 56px;
    height: 56px;
    min-width: 56px;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 0;
    border: none;
  }

  .card-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 0;
  }

  .card-content {
    flex: 1;
    text-align: left;
  }

  .card-tag {
    font-size: 10px;
    padding: 3px 8px;
    margin-bottom: 6px;
  }

  .card-name {
    font-size: 15px;
  }

  .card-desc {
    font-size: 12px;
  }

  .hardware-group {
    margin-bottom: 24px;
  }

  .hardware-group-title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .hardware-flex-list {
    flex-direction: column;
    gap: 12px;
  }

  .hardware-flex-card {
    flex-direction: row;
    padding: 12px;
    gap: 12px;
    width: 100%;
    align-items: center;
  }

  .hardware-flex-image {
    width: 60px;
    height: 100%;
    min-width: 60px;
    padding: 0;
  }

  .hardware-flex-content {
    padding: 0;
  }

  .hardware-flex-name {
    font-size: 14px;
  }

  .hardware-flex-desc {
    font-size: 12px;
  }

  .hardware-flex-protocol {
    font-size: 11px;
  }

  .core-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .core-card {
    padding: 20px;
  }

  .core-slogan {
    font-size: 20px;
  }

  .core-title {
    font-size: 16px;
  }

  .core-desc {
    font-size: 13px;
  }

  .selling-grid {
    gap: 16px;
  }

  .selling-card {
    padding: 20px;
  }

  .selling-title {
    font-size: 16px;
  }

  .selling-subtitle {
    font-size: 13px;
  }

  .selling-desc {
    font-size: 13px;
  }

  .content-card {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }

  .content-card.card-reverse {
    flex-direction: column;
  }

  .content-image {
    width: 100%;
    min-width: 100%;
  }

  .content-text {
    padding: 0;
  }

  .content-title {
    font-size: 18px;
  }

  .content-desc {
    font-size: 13px;
  }

  .content-points {
    font-size: 13px;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .feature-card {
    padding: 20px;
  }

  .feature-title {
    font-size: 16px;
  }

  .feature-desc {
    font-size: 13px;
  }

  .advantages-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .advantage-card {
    padding: 20px;
    flex-direction: row;
    text-align: left;
    gap: 12px;
  }

  .advantage-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }

  .advantage-title {
    font-size: 15px;
  }

  .advantage-desc {
    font-size: 13px;
  }

  /* 典型案例轮播 */
  .case-card {
    flex-direction: column;
  }

  .case-image {
    flex: 0 0 100%;
    height: 200px;
  }

  .case-content {
    padding: 20px;
  }

  .case-title {
    font-size: 20px;
  }

  .case-desc {
    font-size: 14px;
  }

  .case-image img {
    object-fit: inherit;
  }

  .carousel-nav {
    width: 36px;
    height: 36px;
  }

  .carousel-nav svg {
    width: 16px;
    height: 16px;
  }

  .carousel-prev {
    left: 5px;
  }

  .carousel-next {
    right: 5px;
  }

  .cta {
    padding: 48px 16px;
  }

  .cta-title {
    font-size: 22px;
  }

  .cta-desc {
    font-size: 14px;
  }

  .cta-points {
    flex-direction: column;
    gap: 8px;
  }

  .cta-slogans {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .cta-btns {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .cta-btns .btn {
    width: 100%;
    max-width: 240px;
  }

  .footer {
    padding: 32px 16px;
  }

  .footer-center {
    gap: 12px;
  }

  .footer-logo {
    gap: 10px;
  }

  .footer-logo-img {
    width: 40px;
    height: 40px;
  }

  .footer-logo-text {
    font-size: 18px;
  }

  .footer-slogan {
    font-size: 13px;
  }

  .footer-center {
    flex-direction: column;
    align-items: center;
  }

  .footer-main {
    flex-direction: column;
    align-items: center;
  }

  .footer-contact-strip {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    z-index: 100;
  }

  .contact-btn {
    width: 44px !important;
    height: 44px;
    padding: 0;
  }

  .contact-btn:hover,
  .contact-btn.active {
    width: 165px !important;
    padding: 0 12px;
    justify-content: flex-start;
  }

  .contact-btn-qr:hover,
  .contact-btn-qr.active {
    width: 100px !important;
    padding: 10px !important;
    justify-content: flex-start;
  }

  .contact-btn-qr:hover .contact-qr-icon,
  .contact-btn-qr.active .contact-qr-icon {
    display: none;
  }

  .contact-btn-qr:hover img,
  .contact-btn-qr.active img {
    display: block;
  }

  .contact-btn-qr:hover .contact-btn-icon,
  .contact-btn-qr.active .contact-btn-icon {
    position: static;
    transform: none;
    margin-bottom: 4px;
  }

  .contact-btn-text {
    opacity: 0 !important;
    width: 0 !important;
    font-size: 12px;
  }

  .contact-btn:hover .contact-btn-text {
    opacity: 1 !important;
    width: auto !important;
  }

  .contact-btn-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .contact-btn:hover .contact-btn-icon {
    position: static;
    transform: none;
  }

  .footer-filing {
    display: block;
    font-size: 12px;
  }

  .footer-filing a {
    font-size: 12px;
  }

  .footer-icp {
    font-size: 12px;
  }

  .footer-copyright {
    font-size: 12px;
  }

  .filing-icon {
    width: 14px;
    height: 14px;
  }

  /* 轮播图移动端 */
  .cases-carousel {
    max-width: 100%;
    padding: 0 40px;
  }

  .carousel-slide {
    flex: 0 0 90%;
  }

  .case-image {
    height: 310px;
  }

  .carousel-nav {
    width: 32px;
    height: 32px;
  }

  .carousel-nav svg {
    width: 14px;
    height: 14px;
  }

  .carousel-prev {
    left: 2px;
  }

  .carousel-next {
    right: 2px;
  }

  .carousel-slide.is-center {
    transform: scale(1);
  }

  .contact-btn-qr.active {
    width: 100px !important;
    padding: 10px !important;
    justify-content: flex-start;
  }

  .contact-btn-qr.active .contact-qr-icon {
    display: none;
  }

  .contact-btn-qr.active img {
    display: block;
  }

  .contact-btn-qr.active .contact-btn-icon {
    position: static;
    transform: none;
    margin-bottom: 4px;
  }

}

@media (max-width: 600px) {
  .case-image {
    height: 230px;
  }
  .carousel-slide {
    flex: 0 0 110%;
  }
}

@media (max-width: 500px) {
  .case-image {
    height: 200px;
  }
  .carousel-slide {
    flex: 0 0 120%;
  }
}

@media (max-width: 450px) {
  .case-image {
    height: 180px;
  }
  .carousel-slide {
    flex: 0 0 130%;
  }
}

/* 图片预览弹窗 */
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.preview-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image {
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  transition: transform 0.1s ease;
  user-select: none;
}

.preview-tools {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 12px;
  background: rgba(255, 255, 255, 0.15);
  padding: 10px 16px;
  border-radius: 30px;
  backdrop-filter: blur(10px);
}

.preview-tool-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.preview-tool-btn:hover {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.1);
}

.preview-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-close:hover {
  opacity: 0.8;
}

</style>
